import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth';

/**
 * Guards nested routes. When there is no session, redirects to the login page
 * and preserves the attempted location in the `redirect` query parameter. An
 * explicit sign-out never carries a `redirect`, so the login page starts clean.
 */
export function RequireAuth() {
  const { isAuthenticated, signedOut } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const target = `${location.pathname}${location.search}`;
    const search = !signedOut && target !== '/' ? `?redirect=${encodeURIComponent(target)}` : '';

    return <Navigate to={`/login${search}`} replace />;
  }

  return <Outlet />;
}
